/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Hero_BreadcrumbInputs */

const es_gift_hero_breadcrumb = /** @type {(inputs: Gift_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regala Zarpar`)
};

const gl_gift_hero_breadcrumb = /** @type {(inputs: Gift_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agasalla Zarpar`)
};

const en_gift_hero_breadcrumb = /** @type {(inputs: Gift_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar gifts`)
};

/**
* | output |
* | --- |
* | "Zarpar gifts" |
*
* @param {Gift_Hero_BreadcrumbInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_hero_breadcrumb = /** @type {((inputs?: Gift_Hero_BreadcrumbInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Hero_BreadcrumbInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_hero_breadcrumb(inputs)
	if (locale === "en") return en_gift_hero_breadcrumb(inputs)
	return es_gift_hero_breadcrumb(inputs)
});